import { IAcl, ILoginResponse, ISessionBadge, ISettings, ELoginState, IUnits } from '@interfaces/App.interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import App from '@gral/app';
import { IElementType, IUser, IEventType, IReadingType, IStatusIndicator } from '@ts/ui-models';
import { TTextType } from '@ts/storybook';

export interface IGlobal {
  user: ILoginResponse | null;
  language: string;
  settings: ISettings | null;
  sessionBadge: ISessionBadge | null; //Role
  aclList: Record<string, IAcl>;
  notification: TTextType | null;
  loginState: ELoginState;
  //GlobalInfoApp
  elementsTypesList: IElementType[];
  usersList: IUser[];
  eventsTypesList: IEventType[];
  readingTypesList: IReadingType[];
  unitsList: IUnits[];
  indicatorList: IStatusIndicator[];
  autoSaveLists: Record<string, any[]>;
}
export type TGlobalKey = keyof IGlobal;

const initialState: IGlobal = {
  user: null,
  language: 'en',
  elementsTypesList: [],
  usersList: [],
  eventsTypesList: [],
  readingTypesList: [],
  settings: null,
  sessionBadge: App.cxStore.getSessionBadge() || null,
  aclList: App.cxStore.getAclList() || {}, //List of ACL
  notification: null, //Obj for show any notification / message
  loginState: App.cxStore.getToken() ? ELoginState.LOGGING_IN : ELoginState.LOGGED_OUT,
  unitsList: [],
  indicatorList: [],
  autoSaveLists: {}, //Object to save list from backend that no need to refresh
};

//const globalEntity = createEntityAdapter<Global>();

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    cleanNotification(state) {
      state.notification = null;
    },
    notification(state, { payload }: PayloadAction<TTextType>) {
      const message = payload;
      if (message) {
        state.notification = message;
      }
    },
    updateGlobalState(state, action: PayloadAction<{ key: TGlobalKey; value: any }>) {
      const { key, value } = action.payload;
      if (key) {
        state[key] = value;

        if (key === 'settings') {
          state.loginState = ELoginState.LOGGED_IN;
        }
      }
    },
    autoSaveList(state, action: PayloadAction<{ key: string; value: any }>) {
      const { key, value } = action.payload;

      if (key) {
        state.autoSaveLists[key] = value;
      }
    },
    updateDataGridConfig(state, action: PayloadAction<{ key: TGlobalKey; value: any }>) {
      const { value } = action.payload;
      if (state.settings) {
        state.settings.dataGridConfig = value.value;
      }
    },
    updateRole(state, action: PayloadAction<ISessionBadge>) {
      state.sessionBadge = action.payload;
    },
    //#region Login & logout
    loginSuccess(state, action: PayloadAction<ILoginResponse>) {
      const user = action.payload;
      App.cxStore._loginSuccess(user);
      // sessionStorage.setItem('sessionData', JSON.stringify({ user: user, sessionBadge: user.currentLoginBadge }));
      state.user = user;
      state.sessionBadge = user.loginBadge;
      state.loginState = ELoginState.LOADING_USER_PARAMS;
    },
    logout(state) {
      state.loginState = ELoginState.LOGGED_OUT;
      state.sessionBadge = null;
      state.settings = null;
      localStorage.clear();
      sessionStorage.clear();
    },
    //#endregion
  },
});

export const globalActions = globalSlice.actions;

export const globalSelectors = (state: Global) => state;
